export default __webpack_public_path__ + "static/ahu_b.925b7a6d9eea04fec44c2b480a9324b7.svg";